import React from "react";
import _ from "lodash";
var numeral = require("numeral");

const TablaParametrosTalonario = ({ detalle, actionRow }) => {
    return (
        <div className="table-responsive">
            <table className="table table-bordered widget-table align-middle rounded table-sm table-hover table-striped">
                <thead>
                    <tr className="text-nowrap">
                        <th>CAMPO</th>
                        <th>TOP</th>
                        <th>LEFT</th>
                        <th>WIDTH</th>
                        <th>LINE HEIGHT</th>
                        <th>BORDER</th>
                        <th width="10%"></th>
                    </tr>
                </thead>

                <tbody>
                    {_.map(detalle, (item, i) => (
                        <tr key={i}>
                            <td>{item.campo}</td>
                            <td className="fw-bold text-gray-600">{item.top}</td>
                            <td className="text-nowrap">{item.left}</td>
                            <td className="text-nowrap">{item.width}</td>
                            <td className="text-nowrap">{item.lineHeight}</td>
                            <td className="text-nowrap">{item.border}</td>
                            <td className="text-nowrap">
                                <button className={"btn btn-xs w-40px btn-primary"} onClick={() => actionRow("update", i)}>
                                    <i className="fa fa-edit"></i>{" "}
                                </button>
                                <button className={"btn btn-xs w-40px btn-danger ms-1"} onClick={() => actionRow("remove", i)}>
                                    <i className="fa fa-times"></i>{" "}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TablaParametrosTalonario;
